import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visa-service',
  templateUrl: './visa-service.component.html',
  styleUrls: ['./visa-service.component.css']
})
export class VisaServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    document.getElementById('top-hide').style.display="none";
  }

}
